import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import viewVTProviders from './viewVTProviders';
import permissionTypes from '../components/atoms/permissionsGate/permissionTypes';

export default {
  attributeName: 'agreements',
  isDragable: false,
  canOpen: false,
  canEdit: false,  
  permissionToCreate: [permissionTypes.APP_MANAGER_APP_CREATE, permissionTypes.ADMIN_ORGANIZATION],
  permissionToRemove: [permissionTypes.APP_MANAGER_APP_REMOVE, permissionTypes.ADMIN_ORGANIZATION],
  permissionToUpdate: [permissionTypes.APP_MANAGER_APP_UPDATE, permissionTypes.ADMIN_ORGANIZATION],
  canCreate: true,
  canRemove: true,
  emptyMessage: "You don't have agreements in this, click on the \"+\" icon to create one.",
  fields: [
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'The name of the organization',
      canEdit: true,
      canCreate: true,
      width: '12rem',

    },
    {
      attributeName: 'agreementFileId',
      label: 'Terms and conditions',
      type: FormInputTypes.DOWNLOADABLE,
      helpText: 'Downloadable file with the terms and conditions',
      fileType: ['.pdf'],
      hasSelect:false,
      canEdit: true,
      canCreate: true,
      width: '12rem',

    },
    {
      attributeName: 'price',
      label: 'Price €',
      type: FormInputTypes.NUMBER,
      helpText: 'Price of agreement',
      canEdit: true,
      canCreate: true,
      width: '12rem',

    },
    {
      attributeName: 'revenue',
      label: 'Revenue %',
      type: FormInputTypes.NUMBER,
      helpText: 'Revenue of agreement',
      canEdit: true,
      canCreate: true,
      width: '12rem',

    },
    {
      attributeName: 'vtproviders',
      label: 'VT Providers',
      type: FormInputTypes.RELATIONSHIP,
      canEdit: true,
      canCreate: true,
      canFilter: false,
      configFile: viewVTProviders,
      default: [],
      helpText: 'Virtual tickers providers.',
    },
    {
      attributeName: 'status',
      type: FormInputTypes.SELECT,
      label: 'Status',
      canEdit: true,
      canCreate: true,
      helpText: 'Determine whether the agreement is active or not',
      errorText: '',
      width: '12rem',
      options: [
        { name: 'Choose Status', value: 'undefined'},
        { name: 'Enabled', value: 'enabled' },
        { name: 'Disabled', value: 'disabled'}        
        
      ],
    },  

    
  ],
};
